module.exports = __webpack_public_path__ + "media/transport_protocols/HomePickup-35849cc4.svg";